import { createContext, useContext, useState, ReactNode } from "react";

type Lang = "ja" | "en";

const translations = {
  ja: {
    siteName: "Buy the World",
    heroTitle: "世界を買えろ",
    heroSubtitle: "100㎡ = 1ブロック = ¥100　あなただけの土地を世界中に",
    heroBtn: "マップを見る",
    navLogin: "ログイン",
    navRegister: "新規登録",
    navLogout: "ログアウト",
    navMyLand: "マイランド",
    mapTitle: "ワールドマップ",
    buyBlock: "この区画を購入",
    blockPrice: "¥100",
    blockOwned: "所有済み",
    blockOcean: "海域（購入不可）",
    blockAvailable: "購入可能",
    buildHouse: "家を建てる",
    buildCompany: "会社を建てる",
    buildPowerPlant: "発電所を建てる",
    sellAuction: "オークションで売る",
    auctionTitle: "オークション出品",
    auctionDuration: "出品期間を選択",
    auction8h: "8時間",
    auction24h: "24時間",
    auction3d: "3日間",
    startAuction: "出品開始",
    cancel: "キャンセル",
    confirm: "確認",
    purchase: "購入する",
    coins: "コイン",
    yourCoins: "所持コイン",
    loginRequired: "ログインが必要です",
    loginToPlay: "ログインしてください",
    featureBuildings: "土地に何でも建てよう",
    featureBuildingsDesc: "ゲーム内コインを使って、自分の土地に様々な建物を建設できます",
    featureAuction: "土地を売却しよう",
    featureAuctionDesc: "所有している土地をオークション形式で他のプレイヤーに売却できます",
    featureLand: "世界中の土地を所有しよう",
    featureLandDesc: "1ブロック¥100から。陸地なら世界中どこでも購入できます",
    buildingHouse: "住宅",
    buildingCompany: "会社",
    buildingPowerPlant: "発電所",
    houseDesc: "快適な居住空間。コイン収入+10/時",
    companyDesc: "ビジネス拠点。コイン収入+50/時",
    powerPlantDesc: "エネルギー施設。コイン収入+100/時",
    houseCost: "500コイン",
    companyCost: "2,000コイン",
    powerPlantCost: "5,000コイン",
    myBlocks: "所有区画",
    activeAuctions: "進行中のオークション",
    statsTitle: "リアルタイム統計",
    totalBlocks: "総販売区画",
    totalOwners: "所有者数",
    todayTrades: "本日の取引",
    footerTerms: "利用規約",
    footerPrivacy: "プライバシーポリシー",
    footerPayment: "お支払い方法",
    footerRegister: "新規登録",
    footerFaq: "よくある質問",
    footerCopyright: "© 2026 Buy the World. All rights reserved.",
    language: "言語",
    blockCoords: "座標",
    blockId: "区画ID",
    insufficientCoins: "コインが不足しています",
    buildSuccess: "建設完了！",
    purchaseSuccess: "購入完了！",
    auctionSuccess: "オークション出品しました！",
    myPage: "マイページ",
    loginTitle: "ログイン",
    registerTitle: "新規登録",
    emailLabel: "メールアドレス",
    passwordLabel: "パスワード",
    usernameLabel: "ユーザー名",
    loginSubmit: "ログイン",
    registerSubmit: "登録する",
    switchToRegister: "アカウントをお持ちでない方はこちら",
    switchToLogin: "すでにアカウントをお持ちの方はこちら",
    auctionBid: "入札する",
    currentBid: "現在の入札額",
    timeLeft: "残り時間",
    seller: "出品者",
    zoomIn: "ズームイン",
    zoomInHint: "もっとズームインすると区画が選択できます",
    // mypage
    loginRequired: "ログインが必要です",
    loginRequiredDesc: "マイページを表示するにはログインしてください",
    loginBtn: "ログイン",
    tabOverview: "概要",
    tabBlocks: "所有区画",
    tabBuildings: "建物管理",
    tabIncome: "コイン収入",
    buyMoreBlocks: "もっと区画を購入しよう",
    buyMoreBlocksDesc: "世界中の土地を手に入れて収入を増やそう！",
    goToMap: "マップへ",
    // profile
    playerBadge: "プレイヤー",
    joinedAt: "参加",
    copiedId: "コピーしました",
    coinBalance: "コイン残高",
    incomePerHour: "/h 収入中",
    logoutBtn: "ログアウト",
    // buildings
    buildingMgmt: "建物管理",
    buildingTotal: "合計",
    buildingUnit: "棟",
    buildingHouseLabel: "住宅",
    buildingCompanyLabel: "会社",
    buildingPowerPlantLabel: "発電所",
    buildingHouseDesc: "居住者を受け入れ安定収入",
    buildingCompanyDesc: "従業員採用・製品製造・財務管理",
    buildingPowerPlantDesc: "電力生産・供給契約で大収益",
    buildCostPerUnit: "建設コスト/棟",
    incomePerHourPerUnit: "収入/h/棟",
    totalIncomePerHour: "合計収入/h",
    totalInvestment: "総投資額",
    buildingListTitle: "建物一覧 — クリックで詳細管理",
    noBuildingsTitle: "建物がありません",
    noBuildingsDesc: "区画を購入してから建物を建てよう！",
    // owned blocks
    ownedBlocksTitle: "所有区画一覧",
    filterAll: "すべて",
    filterOwned: "保有中",
    filterAuction: "出品中",
    sortByCoords: "座標順",
    sortByBuildings: "建物数順",
    sortByIncome: "収入順",
    sortByStatus: "ステータス順",
    buildingCount: "建物",
    incomeLabel: "収入",
    onAuction: "出品中",
    holding: "保有中",
    mapBtn: "マップ",
    noBlocksTitle: "区画がありません",
    noBlocksDesc: "マップで区画を購入してみよう！",
    builtOn: "建設:",
    noBuildingOnBlock: "建物なし — マップから建設できます",
    // ranking
    rankingTitle: "ランキング",
    rankingDesc: "世界中のプレイヤーと競い合おう",
    rankOwnedBlocks: "所有区画数",
    rankHourlyIncome: "コイン収入",
    rankTotalBuildings: "建物数",
    rankCoins: "コイン残高",
    rankAuctionWins: "落札数",
    unitBlocks: "区画",
    unitCoinsH: "coins/h",
    unitBuildings: "棟",
    unitCoins: "coins",
    unitTimes: "回",
    yourRank: "あなたの順位",
    youBadge: "あなた",
    colPlayer: "プレイヤー",
    colBlocks: "区画",
    colIncome: "収入/h",
    joinedMonth: "参加",
    rankingCTATitle: "ランキングに参加しよう",
    rankingCTADesc: "区画を購入して建物を建て、トップを目指せ！",
    startNow: "今すぐ始める",
    // stock market
    stockMarketTitle: "株式市場",
    stockMarketDesc: "上場企業の株式を売買できます",
    portfolioValue: "ポートフォリオ評価額",
    portfolioPnL: "損益",
    holdingCount: "保有銘柄",
    searchCompany: "企業名・業種で検索",
    marketOverview: "市場概況",
    listedCompanies: "上場企業数",
    totalMarketCap: "総時価総額",
    noCompanyFound: "該当する企業がありません",
    myPortfolio: "保有株式",
    listedBadge: "上場",
    companyDetail: "会社詳細",
    currentPrice: "現在値",
    dayHigh: "本日高値",
    dayLow: "本日安値",
    volume: "出来高",
    unitShares: "株",
    myHolding: "保有株数",
    avgBuyPrice: "平均取得価格",
    evalValue: "評価額",
    pnlLabel: "損益",
    tabChart: "チャート",
    tabOrderBook: "注文板",
    tabShareholders: "株主",
    selectCompany: "銘柄を選択してください",
    selectCompanyDesc: "左のリストから企業を選ぶと詳細が表示されます",
    homeNav: "ホーム",
  },
  en: {
    siteName: "Buy the World",
    heroTitle: "Buy the World",
    heroSubtitle: "100m² = 1 Block = ¥100. Own land anywhere on Earth.",
    heroBtn: "View Map",
    navLogin: "Login",
    navRegister: "Register",
    navLogout: "Logout",
    navMyLand: "My Land",
    mapTitle: "World Map",
    buyBlock: "Buy This Block",
    blockPrice: "¥100",
    blockOwned: "Owned",
    blockOcean: "Ocean (not purchasable)",
    blockAvailable: "Available",
    buildHouse: "Build House",
    buildCompany: "Build Company",
    buildPowerPlant: "Build Power Plant",
    sellAuction: "Sell via Auction",
    auctionTitle: "List on Auction",
    auctionDuration: "Select Duration",
    auction8h: "8 Hours",
    auction24h: "24 Hours",
    auction3d: "3 Days",
    startAuction: "Start Auction",
    cancel: "Cancel",
    confirm: "Confirm",
    purchase: "Purchase",
    coins: "Coins",
    yourCoins: "Your Coins",
    loginRequired: "Login Required",
    loginToPlay: "Please login to continue",
    featureBuildings: "Build on Your Land",
    featureBuildingsDesc: "Use in-game coins to build various structures on your land",
    featureAuction: "Sell Your Land",
    featureAuctionDesc: "Sell your owned land to other players via auction",
    featureLand: "Own Land Worldwide",
    featureLandDesc: "From ¥100 per block. Buy any land parcel anywhere on Earth",
    buildingHouse: "House",
    buildingCompany: "Company",
    buildingPowerPlant: "Power Plant",
    houseDesc: "Cozy living space. +10 coins/hr",
    companyDesc: "Business HQ. +50 coins/hr",
    powerPlantDesc: "Energy facility. +100 coins/hr",
    houseCost: "500 Coins",
    companyCost: "2,000 Coins",
    powerPlantCost: "5,000 Coins",
    myBlocks: "My Blocks",
    activeAuctions: "Active Auctions",
    statsTitle: "Live Statistics",
    totalBlocks: "Blocks Sold",
    totalOwners: "Owners",
    todayTrades: "Today\'s Trades",
    footerTerms: "Terms of Service",
    footerPrivacy: "Privacy Policy",
    footerPayment: "Payment Methods",
    footerRegister: "Register",
    footerFaq: "FAQ",
    footerCopyright: "© 2026 Buy the World. All rights reserved.",
    language: "Language",
    blockCoords: "Coordinates",
    blockId: "Block ID",
    insufficientCoins: "Insufficient coins",
    buildSuccess: "Build complete!",
    purchaseSuccess: "Purchase complete!",
    auctionSuccess: "Listed on auction!",
    myPage: "My Page",
    loginTitle: "Login",
    registerTitle: "Register",
    emailLabel: "Email",
    passwordLabel: "Password",
    usernameLabel: "Username",
    loginSubmit: "Login",
    registerSubmit: "Register",
    switchToRegister: "Don\'t have an account? Register",
    switchToLogin: "Already have an account? Login",
    auctionBid: "Place Bid",
    currentBid: "Current Bid",
    timeLeft: "Time Left",
    seller: "Seller",
    zoomIn: "Zoom In",
    zoomInHint: "Zoom in more to select blocks",
    // mypage
    loginRequired: "Login Required",
    loginRequiredDesc: "Please log in to view your page",
    loginBtn: "Login",
    tabOverview: "Overview",
    tabBlocks: "My Blocks",
    tabBuildings: "Buildings",
    tabIncome: "Coin Income",
    buyMoreBlocks: "Buy More Blocks",
    buyMoreBlocksDesc: "Acquire land around the world and grow your income!",
    goToMap: "Go to Map",
    // profile
    playerBadge: "Player",
    joinedAt: "Joined",
    copiedId: "Copied!",
    coinBalance: "Coin Balance",
    incomePerHour: "/h income",
    logoutBtn: "Logout",
    // buildings
    buildingMgmt: "Building Management",
    buildingTotal: "Total",
    buildingUnit: "buildings",
    buildingHouseLabel: "House",
    buildingCompanyLabel: "Company",
    buildingPowerPlantLabel: "Power Plant",
    buildingHouseDesc: "Accept residents for stable income",
    buildingCompanyDesc: "Hire staff, manufacture products, manage finances",
    buildingPowerPlantDesc: "Generate power and earn from supply contracts",
    buildCostPerUnit: "Build cost/unit",
    incomePerHourPerUnit: "Income/h/unit",
    totalIncomePerHour: "Total income/h",
    totalInvestment: "Total investment",
    buildingListTitle: "Buildings — Click to manage",
    noBuildingsTitle: "No buildings yet",
    noBuildingsDesc: "Buy a block and start building!",
    // owned blocks
    ownedBlocksTitle: "Owned Blocks",
    filterAll: "All",
    filterOwned: "Owned",
    filterAuction: "On Auction",
    sortByCoords: "By Coords",
    sortByBuildings: "By Buildings",
    sortByIncome: "By Income",
    sortByStatus: "By Status",
    buildingCount: "Buildings",
    incomeLabel: "Income",
    onAuction: "On Auction",
    holding: "Holding",
    mapBtn: "Map",
    noBlocksTitle: "No blocks yet",
    noBlocksDesc: "Buy a block on the map!",
    builtOn: "Built:",
    noBuildingOnBlock: "No buildings — build from the map",
    // ranking
    rankingTitle: "Ranking",
    rankingDesc: "Compete with players around the world",
    rankOwnedBlocks: "Owned Blocks",
    rankHourlyIncome: "Coin Income",
    rankTotalBuildings: "Buildings",
    rankCoins: "Coin Balance",
    rankAuctionWins: "Auction Wins",
    unitBlocks: "blocks",
    unitCoinsH: "coins/h",
    unitBuildings: "bldgs",
    unitCoins: "coins",
    unitTimes: "wins",
    yourRank: "Your Rank",
    youBadge: "You",
    colPlayer: "Player",
    colBlocks: "Blocks",
    colIncome: "Income/h",
    joinedMonth: "Joined",
    rankingCTATitle: "Join the Ranking",
    rankingCTADesc: "Buy blocks, build structures, and aim for the top!",
    startNow: "Start Now",
    // stock market
    stockMarketTitle: "Stock Market",
    stockMarketDesc: "Buy and sell shares of listed companies",
    portfolioValue: "Portfolio Value",
    portfolioPnL: "P&L",
    holdingCount: "Holdings",
    searchCompany: "Search by company or industry",
    marketOverview: "Market Overview",
    listedCompanies: "Listed Companies",
    totalMarketCap: "Total Market Cap",
    noCompanyFound: "No companies found",
    myPortfolio: "My Portfolio",
    listedBadge: "Listed",
    companyDetail: "Company Detail",
    currentPrice: "Current Price",
    dayHigh: "Day High",
    dayLow: "Day Low",
    volume: "Volume",
    unitShares: "shares",
    myHolding: "Shares Held",
    avgBuyPrice: "Avg Buy Price",
    evalValue: "Market Value",
    pnlLabel: "P&L",
    tabChart: "Chart",
    tabOrderBook: "Order Book",
    tabShareholders: "Shareholders",
    selectCompany: "Select a company",
    selectCompanyDesc: "Choose a company from the list to view details",
    homeNav: "Home",
  },
} as const;

export type TranslationKeys = keyof typeof translations.ja;

interface LanguageContextType {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: TranslationKeys) => string;
}

const LanguageContext = createContext<LanguageContextType | null>(null);

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>("ja");
  const t = (key: TranslationKeys): string => translations[lang][key] as string;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
